/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_Placements_Left_Rail_LabelInputs */

const en_directory_promotion_placements_left_rail_label = /** @type {(inputs: Directory_Promotion_Placements_Left_Rail_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Left discovery rail`)
};

const zh_directory_promotion_placements_left_rail_label = /** @type {(inputs: Directory_Promotion_Placements_Left_Rail_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`左侧发现栏`)
};

/**
* | output |
* | --- |
* | "Left discovery rail" |
*
* @param {Directory_Promotion_Placements_Left_Rail_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_placements_left_rail_label = /** @type {((inputs?: Directory_Promotion_Placements_Left_Rail_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_Placements_Left_Rail_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_placements_left_rail_label(inputs)
	return zh_directory_promotion_placements_left_rail_label(inputs)
});
export { directory_promotion_placements_left_rail_label as "directory.promotion.placements.left-rail.label" }